import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { AdjacentType, edgeTypeMatrix, getEntityProgrammeToEntityEdgeTypeId, getGroupToEntityEdgeTypeId } from '@iotv/datamodel-core';
import { TypeIcons } from '../../../Iconography';
import { DefaultStepTypeFolderClickWrapper, ObjectTree } from '../../../v2/components/generic/ObjectTree';
import { ContextMenu } from '../ContextMenuV2/ContextMenu';
const debug = process.env.REACT_APP_DEBUG && false;
/** Customer to Programme Set */
export const customerProgrammeSetsTreeDef = {
    stepQuery: {
        objectTypeId: 'EntityProgrammeSet',
        adjacencyType: AdjacentType.CHILD,
        edgeTypeId: edgeTypeMatrix.Customer.EntityProgrammeSet.customer_has_entity_programme_set.edgeTypeId,
    },
    endIcon: TypeIcons.EntityProgrammeSet,
    nextSteps: [],
    renderTypeFolder: false,
    thisStepTypeFolderClickWrapper: (props) => (_jsx(DefaultStepTypeFolderClickWrapper, { ...props, element: _jsx(_Fragment, { children: "Programme Sets" }), support: 'EntityProgamme' })),
    thisStepLabelWrapper: ({ vob, ascendentAccessor }) => (_jsx(ContextMenu, { ascendentAccessor,
        contextObject: vob,
        popUpElement: null,
        edgeTypeIdFilter: [edgeTypeMatrix.EntityProgrammeSet.EntityProgramme.programme_set_has_programmes.edgeTypeId],
        // CRA 2025 05 — disabled as there are special methods required for creating Programmes in a ProgrammeSet which are handled by the ProgrammeSet UI
        hideAdd: true })),
};
const programmeSetToProgrammeStep = {
    stepQuery: {
        objectTypeId: 'EntityProgramme',
        adjacencyType: AdjacentType.CHILD,
        edgeTypeId: edgeTypeMatrix.EntityProgrammeSet.EntityProgramme.programme_set_has_programmes.edgeTypeId,
    },
    endIcon: TypeIcons.EntityProgramme,
    thisStepLabelWrapper: ({ vob, ascendentAccessor }) => (_jsx(ContextMenu, { ascendentAccessor, contextObject: vob, popUpElement: null, edgeTypeIdFilter: [], hideAdd: true, hideDelete: true })),
    itemDerivedTreeFn: (vob, nodeEdgeMapper) => {
        return typeof vob.supportedType === 'string'
            ? [
                _jsx(ObjectTree, { contextObjects: [vob],
                    hideTopStep: true,
                    nodeEdgeMapper,
                    queryPaths: [
                        {
                            stepQuery: {
                                objectTypeId: vob.supportedType,
                                adjacencyType: AdjacentType.CHILD,
                                edgeTypeId: getEntityProgrammeToEntityEdgeTypeId(vob.supportedType),
                            },
                        },
                    ] }, vob.sk),
            ]
            : [];
    },
    nextSteps: [],
};
customerProgrammeSetsTreeDef.nextSteps?.push(programmeSetToProgrammeStep);
const programmeToGroupStep = {
    stepQuery: {
        objectTypeId: 'Group',
        adjacencyType: AdjacentType.CHILD,
        edgeTypeId: getEntityProgrammeToEntityEdgeTypeId('Group'),
    },
    endIcon: TypeIcons.Group,
    thisStepLabelWrapper: ({ vob, ascendentAccessor }) => (_jsx(ContextMenu, { ascendentAccessor, contextObject: vob, popUpElement: null, edgeTypeIdFilter: [], hideAdd: true })),
    itemDerivedTreeFn: (vob, nodeEdgeMapper) => {
        return typeof vob.supportedType === 'string'
            ? [
                _jsx(ObjectTree, { contextObjects: [vob],
                    hideTopStep: true,
                    nodeEdgeMapper,
                    queryPaths: [
                        {
                            stepQuery: {
                                objectTypeId: vob.supportedType,
                                adjacencyType: AdjacentType.CHILD,
                                edgeTypeId: getGroupToEntityEdgeTypeId(vob.supportedType),
                            },
                        },
                    ] }, vob.sk),
            ]
            : [];
    },
    nextSteps: [],
};
programmeSetToProgrammeStep.nextSteps?.push(programmeToGroupStep);
